





















import { Component, Vue } from 'vue-property-decorator';
import ACHAccountForm from '../../components/ACHAccountForm.vue';
import { AddPaymentSourceRequest, ApiRequest } from '../../types/request';
import { ObjectFactory } from '../../config/objectFactory';
import { MedTransGoConstants } from '../../util/constants';
import { CommonUtils } from '../../util/commonUtils';
import { EventBus } from '../../main';
import { ToastEvent } from '../../types/event';
@Component({
   components: {
      ACHAccountForm,
   },
   props: {
        show: Boolean,
        customerId: String,
   },
})
export default class AddACHCardModal extends Vue {

    private paymentSource: string = '';

    private saveACHCard(paymentSource: any) {
        if (paymentSource) {
            this.paymentSource = paymentSource;
        } else {
            this.paymentSource = '';
        }
    }

    private async addACHCard() {
        const addPaymentSourceRequest: AddPaymentSourceRequest = {
            customerId: this.$props.customerId,
            paymentSource: this.paymentSource,
        };
        const response = await ObjectFactory.getPaymentSourceService().addACHCard
        (addPaymentSourceRequest, this.$store.state.serverUrl);
        if (response.success) {
            this.$emit('close');
            this.$emit('success');
        } else {
            CommonUtils.showError(response);
        }
    }

    private close() {
        this.$emit('close');
    }

}

